module.exports = __webpack_public_path__ + "static/media/0017.82a60ac4.jpg";